import CampaignsDialog from "./CampaignsDialog";

export default CampaignsDialog;
